import { Slot } from "@radix-ui/react-slot";
import { type VariantProps, cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

/** C25 批1(P1 按钮体系,对标 Intercom):全圆角 pill。
 * default=暖近黑主按钮 · outline=浅灰底无边框次按钮(Intercom 次级形态,保留旧名免全站改调用)
 * ghost=文字钮 · accent=橙 · danger 仅真毁灭性操作。icon 尺寸=圆形。 */
const buttonVariants = cva(
	"inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full text-sm font-semibold ring-offset-surface-background transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-state-focus focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
	{
		variants: {
			variant: {
				default: "bg-brand-primary text-text-inverse hover:opacity-90",
				accent: "bg-brand-accent text-text-inverse hover:opacity-90",
				outline: "bg-surface-subtle text-text-primary hover:bg-surface-muted",
				ghost: "text-text-primary hover:bg-surface-subtle",
				danger: "bg-brand-danger text-text-inverse hover:opacity-90",
			},
			size: {
				default: "h-8 px-3.5",
				sm: "h-7 px-3 text-xs",
				lg: "h-10 px-5",
				icon: "h-8 w-8",
			},
		},
		defaultVariants: {
			variant: "default",
			size: "default",
		},
	},
);

export interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof buttonVariants> {
	asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	({ className, variant, size, asChild = false, ...props }, ref) => {
		const Comp = asChild ? Slot : "button";
		return (
			<Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
		);
	},
);
Button.displayName = "Button";

export { Button, buttonVariants };
